// src/App.js
import React, { useEffect, useState, useCallback } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./App_funciona"; // o App_funciona
import AboutUs from "./components/pages/AboutUs";
import Contactanos from "./components/pages/Contactanos";
import Celebraciones from "./components/pages/CustomEvents";
import FantasyBall from "./components/pages/FantasyBall";
import LiteraryEvents from "./components/pages/LiteraryEvents";
import PoliticaPrivacidad from "./components/privacity/PoliticaPrivacidad";
import AvisoLegal from "./components/privacity/AvisoLegal";
import PoliticaCookies from "./components/privacity/PoliticaCookies";
import FaqPage from "./components/privacity/FaqPage";
import Linktree from './components/utils/LinkTree';
import NocheCountry from './components/pages/nocheCountry';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/nosotras" element={<AboutUs />} />
        <Route path="/contactanos" element={<Contactanos />} />
        <Route path="/celebraciones" element={<Celebraciones />} />
        <Route path="/bailes" element={<FantasyBall />} />
        <Route path="/eventos" element={<LiteraryEvents />} />
        <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
        <Route path="/aviso-legal" element={<AvisoLegal />} />
        <Route path="/politica-cookies" element={<PoliticaCookies />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/linktree" element={<Linktree />} />     
        <Route path="/eventos/noche-country" element={<NocheCountry />} />  
      </Routes>
    </Router>
  );
}